/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

export const LDPageContainer = styled.div`
  align-items: center;
  color: #333;
  display: flex;
  flex-direction: column;
  font-family: Inter, sans-serif;
  line-height: 14px;
  margin-top: 0px;
  overflow-y: scroll;
  flex-shrink: 0;
`;
